import React, { useEffect } from 'react';
import { App, Button, Result } from 'antd';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from 'config/msalConfig';
import { consumeInviteSignupFlag } from 'utils/inviteSignup';
import './index.css';

const ASSETS_BASE = 'https://birddata.blob.core.windows.net/b2clogin/cust-app/images';

const InviteComplete = () => {
  const { message } = App.useApp();
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = accounts && accounts.length > 0;

  useEffect(() => {
    if (consumeInviteSignupFlag()) {
      message.success('Account created successfully. Please sign in to continue.');
    }
  }, [message]);

  const handleContinue = () => {
    if (isAuthenticated) {
      navigate('/');
      return;
    }
    instance.loginRedirect(loginRequest).catch((error) => console.error(error));
  };

  return (
    <div className="invite-complete">
      <div className="invite-complete__page">
        <div className="invite-complete__topbar">
          <img
            className="invite-complete__logo-small"
            src={`${ASSETS_BASE}/company-logo-1.png`}
            alt="Logo"
          />
          <img
            className="invite-complete__brand"
            src={`${ASSETS_BASE}/company-logo-2.png`}
            alt="The BI Collaborative"
          />
        </div>

        <div className="invite-complete__content">
          <section className="invite-complete__leftmark" aria-hidden="true">
            <div>
              <div className="invite-complete__brandline">
                <img
                  className="invite-complete__logo-small"
                  src={`${ASSETS_BASE}/Insights-Logo.png`}
                  alt="Insights-Logo"
                />
              </div>
              <div className="invite-complete__from">from</div>
              <div className="invite-complete__brandline">
                <img
                  className="invite-complete__logo-small"
                  src={`${ASSETS_BASE}/company-logo-1.png`}
                  alt="Logo"
                />
                <img
                  className="invite-complete__logo-text"
                  src={`${ASSETS_BASE}/company-logo-2.png`}
                  alt="The BI Collaborative"
                />
              </div>
            </div>
          </section>

          <section className="invite-complete__panel" role="status" aria-live="polite">
            <Result
              status="success"
              title="Your account is ready."
              subTitle={isAuthenticated ? 'Continue to the dashboard.' : 'Please access the platform by signing in.'}
              extra={
                <Button type="primary" onClick={handleContinue}>
                  {isAuthenticated ? 'Go to Dashboard' : 'Continue to Login'}
                </Button>
              }
            />
          </section>
        </div>

        <div className="invite-complete__footer">The BI Collaborative · Insights</div>
      </div>
    </div>
  );
};

export default InviteComplete;
